// PlatformFrame — Symbols-brand-mark chrome for projectType='platform'.
// Features the lambda/Symbols brand mark, 16:10 aspect, brand-accent color.

export const PlatformFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  round: 'inherit',
  overflow: 'hidden',
  position: 'relative',

  // Header with Symbols brand mark
  BrandHeader: {
    flexShrink: '0',
    flow: 'x',
    align: 'center',
    padding: 'V A',
    height: 'B',
    background: 'electricBlue.12',
    borderBottom: '1px solid',
    borderColor: 'electricBlue.2',
    gap: 'V',

    // Lambda mark
    Lambda: {
      width: 'Y',
      height: 'Y',
      flexShrink: '0',
      fontSize: 'Z2',
      color: 'electricBlue.85',
      lineHeight: '1',
      text: 'λ',
      fontWeight: '700',
      fontFamily: 'monospace'
    },

    Label: {
      tag: 'span',
      text: 'Platform',
      fontSize: 'Z1',
      color: 'electricBlue.6',
      fontWeight: '600',
      letterSpacing: '0.04em'
    }
  },

  // Viewport — thumbnail insets here
  Viewport: {
    flexGrow: '1',
    position: 'relative',
    overflow: 'hidden',
    background: 'electricBlue.04',

    EmptyState: {
      if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
      position: 'absolute',
      inset: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'Y',
      pointerEvents: 'none',

      Mark: {
        fontSize: 'B2',
        color: 'electricBlue.2',
        text: 'λ',
        fontWeight: '700',
        fontFamily: 'monospace'
      },
      Hint: {
        tag: 'span',
        text: 'Platform project',
        fontSize: 'Z1',
        color: 'white.22',
        fontStyle: 'italic'
      }
    }
  },

  // Electric-blue accent border
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'electricBlue',
    opacity: '0.8',
    pointerEvents: 'none'
  }
}
